<form [formGroup]="frm">
  <!-- Old Password -->
  <mat-form-field class="py-1.5">
    <mat-label>Contraseña Anterior</mat-label>
    <input
      matInput
      [type]="visibleOldPassword ? 'text' : 'password'"
      placeholder="Contraseña"
      formControlName="old_password"
      [disabled]="loading()" />
    <mat-icon
      matSuffix
      color="primary"
      [svgIcon]="visibleOldPassword ? 'visibility_off' : 'visibility'"
      (click)="visibleOldPassword = !visibleOldPassword">
    </mat-icon>
    @if (old_password.hasError('required')) {
      <mat-error>La contraseña es requerida </mat-error>
    }
    @if (old_password.hasError('minlength')) {
      <mat-error>Debe tener al menos 4 caracteres </mat-error>
    }
  </mat-form-field>

  <!-- Password -->
  <mat-form-field class="py-1.5">
    <mat-label>Contraseña</mat-label>
    <input
      matInput
      [type]="visiblePassword ? 'text' : 'password'"
      placeholder="Contraseña"
      formControlName="password"
      [disabled]="loading()" />
    <mat-icon
      matSuffix
      color="primary"
      [svgIcon]="visiblePassword ? 'visibility_off' : 'visibility'"
      (click)="visiblePassword = !visiblePassword">
    </mat-icon>
    @if (password.hasError('required')) {
      <mat-error>La contraseña es requerida </mat-error>
    }
    @if (password.hasError('minlength')) {
      <mat-error>Debe tener al menos 4 caracteres </mat-error>
    }
  </mat-form-field>

  <!-- Confirm password -->

  <mat-form-field class="py-1.5">
    <mat-label>Confirmar contraseña</mat-label>
    <input
      matInput
      [type]="visiblePassword ? 'text' : 'password'"
      placeholder="Contraseña"
      formControlName="confirm_password"
      [disabled]="loading()" />
    <mat-icon
      matSuffix
      color="primary"
      [svgIcon]="visiblePassword ? 'visibility_off' : 'visibility'"
      (click)="visiblePassword = !visiblePassword">
    </mat-icon>
    @if (confirm_password.hasError('required')) {
      <mat-error>La contraseña es requerida </mat-error>
    }
    @if (confirm_password.hasError('fieldsMissMatch')) {
      <mat-error>La contraseñas no coinciden</mat-error>
    }
  </mat-form-field>
  <div class="flex justify-end">
    <button
      type="submit"
      #submitButton
      mat-flat-button
      (click)="onSubmit()"
      [disabled]="loading() || frm.pristine || frm.invalid">
      @if (loading()) {
        <mat-spinner class="mx-3" [diameter]="20"></mat-spinner>
      } @else {
        <ng-container>Guardar</ng-container>
      }
    </button>
  </div>
</form>
